export default __webpack_public_path__ + "static/media/logo_parking.8651a331.svg";